@if (!isDisabled) {
  <bdo-slide-over
    [slideOverHeadline]="slideOverHeadline"
    [slideOverText]="slideOverText"
    [slideOverTelephoneNumber]="slideOverTelephoneNumber"
  ></bdo-slide-over>
}
